import React, { useMemo, useState,useCallback, useEffect } from "react";
import {
  Menu,
  TextField,
} from "@mui/material";
import { VariableSizeList as List } from "react-window";
import CustomCheckbox from "components/Checkbox";
const DEFAULT_ROW_HEIGHT = 34;
const MAX_VISIBLE_ITEMS = 8;
const LIST_WIDTH = 220;
const LanguageDropDown = ({ anchorEl, open, onClose, languages, selectedLanguage = [], setSelectedOtherLanguages }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allAndSelectedItems, setAllAndSelectedItems] = useState(languages);

  useEffect(() => {
    const selectedIds = new Set((selectedLanguage || []).map(l => String(l.id_lang)));
    const withSelection = (languages || []).map(lang => ({
      ...lang,
      isSelected: selectedIds.has(String(lang.id_lang)),
    }));
    setAllAndSelectedItems(withSelection);
  }, [open, languages, selectedLanguage]);

  const filteredItems = useMemo(
    () =>
      allAndSelectedItems
        .filter((language) =>
          [language.language_name]
            .filter(Boolean)
            .some((field) => field.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        .sort((a, b) => {
          if (a.isSelected === b.isSelected) return 0;
          return a.isSelected ? -1 : 1;
        }),
    [searchTerm, allAndSelectedItems]
  );
  // Virtualized row renderer
  const Row = ({ index, style }) => {
    const item = filteredItems[index];
    return (
      <li
        style={{
          ...style,
         
          paddingBlock: "10px",
          height: style.height,
          width: "100%", // Fix width to 100% to avoid horizontal scroll
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          background: "#fff", // Remove alternate background
        }}
      >
        <CustomCheckbox
          fontSize="12px"
          size={"small"}
          checked={item?.isSelected}
          title={item?.label || item?.language_name}
            onChange={() => handleCheckboxChange(item)}
        />
      </li>
    );
  };
  // Dynamic row height calculation (can be customized per item)
  const getRowHeight = useCallback(
    (index) => {
      const item = filteredItems[index];
      const label = item?.label || item?.name || item?.hotel_name || "";
      return label.length > 30 ? DEFAULT_ROW_HEIGHT + 12 : DEFAULT_ROW_HEIGHT;
    },
    [filteredItems]
  );
  const handleCheckboxChange = (item) => {
    // Update the selected state for the clicked item
    const updatedItems = allAndSelectedItems.map((lang) =>
      lang.id_lang === item.id_lang
        ? { ...lang, isSelected: !lang.isSelected }
        : lang
    );
    setAllAndSelectedItems(updatedItems);
    setSelectedOtherLanguages(updatedItems.filter(lang => lang.isSelected)?.map(lang => lang));
  };
  return (
    <>
      <Menu
        sx={{ padding: 0 }}
        PaperProps={{
          sx: {
            borderRadius: "10px",
            maxWidth: LIST_WIDTH + 38,
            minWidth: LIST_WIDTH,
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
      >
        <div
          aria-disabled
          style={{
            paddingInline: "17px",
            paddingTop: "0px",
            paddingBottom: "7px",
            minWidth: LIST_WIDTH,
          }}
        >
          <TextField
            sx={{
              borderColor: "#CADEDD",
              width: LIST_WIDTH,
              height: "28px",
              fontSize: "12px",
              fontWeight: "400",
              fontFamily: "inter",
            }}
            size="small"
            placeholder="Search"
            variant="standard"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div style={{ display: "flex", marginTop: "5px" }}>
            <div style={{ width: "100%" }}>
              <ul
                style={{
                  listStyleType: "none",
                  marginBlock: 0,
                  padding: 0,
                  paddingLeft: "4px",
                  width: "100%",
                  maxWidth: LIST_WIDTH,
                  maxHeight: `${DEFAULT_ROW_HEIGHT * MAX_VISIBLE_ITEMS}px`,
                  overflowY: "auto",
                  overflowX: "hidden", // Prevent horizontal scroll
                }}
              >
                <List
                  height={
                    Math.min(filteredItems.length, MAX_VISIBLE_ITEMS) *
                    DEFAULT_ROW_HEIGHT
                  }
                  itemCount={filteredItems.length}
                  itemSize={getRowHeight}
                  width={"100%"}
                >
                  {Row}
                </List>
              </ul>
            </div>
          </div>
        </div>
      </Menu>
    </>
  );
};

export default LanguageDropDown;
